import React, { useState } from "react"
import { Grid } from '@material-ui/core';
import { Tabs, Button, Row, Col } from 'antd';
import PageContainer from "../../../../../CSIComponents/PageContainer";
import DetailItem from "../../../../../CSIComponents/DetailItem";
import ReadOnlyTextarea from "../../../../../CSIComponents/ReadOnlyTextarea";
const { TabPane } = Tabs;

const AcceptedPaymentDetails = (props: any) => {
  const rowDetail = JSON.parse(JSON.stringify(props.cancellationDetails))
  if (rowDetail.acceptedpayments.length < 1) rowDetail.acceptedpayments.push({ id: 1 })
  rowDetail.acceptedpayments.forEach((item: any, index: number) => {
    item.id = index + 1;
  })
  const panes = rowDetail.acceptedpayments
  const [activeKey, setActiveKey] = useState<any>(JSON.stringify(panes[0]?.id))
  const onChange = (activeKey: any) => {
    setActiveKey(activeKey)
  };
  return (
    <>
      <PageContainer>
        <div style={{ background: '#fff', padding: '20px', position: 'relative' }}>
          <Button className="db-edit-btn" style={{ position: 'absolute', right: '20px', top: '20px', zIndex: 10 }} onClick={() => { props.setActiveTabKey('AcceptedPayment'); props.toggleToEditMode(); props?.accPayEditRef?.current?.resetRequired(true); }}>Edit</Button>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.changeTab('GuaranteePayment') }}>Back</Button>
                    </div>
                    <div>
                      <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Detail'); props.toggleToEditMode(); }}>Edit</Button>
                    </div>
            </div>
          <Tabs
            type="card"
            onChange={onChange}
            activeKey={activeKey}
          >
            {panes.map((pane: any, i: number) => (
              <TabPane tab={'Accepted Payment ' + (i + 1)} key={i + 1}>
                <PageContainer>
                  <Grid item xs={12} className="pb-0 px-0 my-0">
                    <Row gutter={24}>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.paymenttype} label='Payment Type' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.acceptedforguarnatee} label='Use for Guarantee' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.cardtype} label='Card Type' />
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}> 
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.usefordeposit} label='Use for Deposit' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.useforpayment} label='Use for Payment' />
                      </Col>                    
                    </Row>
                    <Row gutter={24}>
                      <Col span={18} className="col-margin">
                        <ReadOnlyTextarea value={pane.description} label='Card Description' />
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                  </Grid>
                </PageContainer>
              </TabPane>
            ))}
          </Tabs>
        </div>
      </PageContainer>
    </>
  )
}

export default AcceptedPaymentDetails
